import {
  AuthCoreAuthClient,
  AuthCoreManagementClient,
  AuthCoreWidgets
} from 'authcore-js'

import router from '@/router'
import {
  GET_ACCESS_TOKEN_COMPLETED,
  GET_CLIENT_COMPLETED,

  SET_AUTHENTICATED_STATE
} from '@/store/types'

const ACCESS_TOKEN_KEY = 'io.authcore.accessToken'

export default {
  namespaced: true,
  modules: {},

  state: {
    authClient: undefined,
    managementClient: undefined,
    authenticated: false
  },
  getters: {
    isReady: (state) => {
      return (state.authClient !== undefined && state.managementClient !== undefined)
    },
    accessToken: (state, getters) => {
      if (getters.isReady) {
        return state.authClient.getAccessToken()
      }
    }
  },

  mutations: {
    // GET_ACCESS_TOKEN_COMPLETED may contains refreshPage payload which indicates
    // the page to be refreshed to Home page, this behaviour is handled in plugins.js
    [GET_ACCESS_TOKEN_COMPLETED] (state, payload) {
      const { accessToken } = payload
      if (accessToken) {
        localStorage.setItem(ACCESS_TOKEN_KEY, accessToken)
      } else {
        localStorage.removeItem(ACCESS_TOKEN_KEY)
      }
    },
    [GET_CLIENT_COMPLETED] (state, payload) {
      const { authClient, managementClient } = payload
      state.authClient = authClient
      state.managementClient = managementClient
    },

    [SET_AUTHENTICATED_STATE] (state, authenticated) {
      state.authenticated = authenticated
    }
  },
  actions: {
    async init ({ commit, dispatch }, accessToken) {
      // Set client
      const authClient = await new AuthCoreAuthClient({
        clientId: 'management',
        accessToken: accessToken,
        apiBaseURL: window.origin,
        callbacks: {
          unauthenticated () {
            commit('SET_AUTHENTICATED_STATE', false)
            router.push({
              name: 'SignIn',
              params: { isShowUnauthenticatedAlert: true }
            })
            commit(GET_ACCESS_TOKEN_COMPLETED, {
              accessToken: null,
              refreshPage: true,
              logout: true
            })
            commit('currentUser/GET_CURRENT_USER_COMPLETED', {}, { root: true })
          }
        }
      })
      const managementClient = await new AuthCoreManagementClient({
        accessToken: accessToken,
        apiBaseURL: window.origin,
        callbacks: {
          unauthenticated: () => {
            commit('SET_AUTHENTICATED_STATE', false)
            router.push({
              name: 'SignIn',
              params: { isShowUnauthenticatedAlert: true }
            })
            commit(GET_ACCESS_TOKEN_COMPLETED, {
              accessToken: null,
              refreshPage: true,
              logout: true
            })
            commit('currentUser/GET_CURRENT_USER_COMPLETED', {}, { root: true })
          }
        }
      })
      commit(GET_CLIENT_COMPLETED, { authClient, managementClient })
    },
    async updateAccessToken ({ commit, state }, payload) {
      const { accessToken, refreshPage = false } = payload
      commit(GET_ACCESS_TOKEN_COMPLETED, {
        accessToken: accessToken,
        refreshPage: refreshPage
      })
      await state.authClient.setAccessToken(accessToken)
      await state.managementClient.setAccessToken(accessToken)
      commit('SET_AUTHENTICATED_STATE', true)
    },
    async logout ({ commit, state }) {
      await state.authClient.signOut()
      // Using SignOut widget to remove refresh token in authcore domain
      // eslint-disable-next-line no-new
      new AuthCoreWidgets.SignOut({
        clientId: 'management',
        onRefreshTokenRemoved () {
          commit(GET_ACCESS_TOKEN_COMPLETED, {
            accessToken: null,
            refreshPage: true,
            logout: true
          })
          commit('currentUser/GET_CURRENT_USER_COMPLETED', {}, { root: true })
        }
      })
    }
  }
}
